import { episodeConstants } from './constants/episodeConstants';

const episodeSave = (episodesInput: any) => {
	return {
		type: episodeConstants.EpisodeSaveRequest,
		input: episodesInput
	};
};

const episodeGetDetail = (id: any) => {
	return {
		type: episodeConstants.EpisodeGetDetailRequest,
		input: id
	};
};

const episodeGetMinDate = () => {
	return {
		type: episodeConstants.EpisodeGetMinDateRequest,
	};
};

const episodeGetDropDownList = () => {
	return {
		type: episodeConstants.EpisodeGetDropdownRequest,
	};
};

const episodeGetByFilter = (filterInput: any) => {
	return {
		type: episodeConstants.EpisodeGetByFilterRequest,
		input: filterInput
	};
};

const episodeDelete = (id: any) => {
	return {
		type: episodeConstants.EpisodeDeleteRequest,
		input: id
	};

};

const episodeGetReading = (filterInput: any) => {
	return {
		type: episodeConstants.EpisodeGetReadingRequest,
		input: filterInput
	};
};

const episodeGetUserCountByYear = (filterInput: any) => {
	return {
		type: episodeConstants.EpisodeGetUserCountRequest,
		input: filterInput
	};
};


const episodeGetUserEngagement = (filterInput: any) => {
	return {
		type: episodeConstants.EpisodeGetUserEngagementRequest,
		input: filterInput
	};
};
const episodeValidateFeed = ()=>{
	return {
		type: episodeConstants.EpisodeValidateFeedRequest,
		//input: inputDateAtUtc
	}
}

const episodeUserMetric = () => {
	return {
		type: episodeConstants.EpisodeUserMetricRequest,
	};
};

const episodeUpdateEngagement = (input: any, meta?: any) => {
	return {
		type: episodeConstants.EpisodeUpdateEngagementRequest,
		input: input,
		meta: meta
	};
};

export const episodeAction = {
	episodeSave,
	episodeGetDetail,
	episodeGetDropDownList,
	episodeGetByFilter,
	episodeDelete,
	episodeGetReading,
	episodeGetUserCountByYear,
	episodeGetUserEngagement,
	episodeGetMinDate,
	episodeValidateFeed,
	episodeUserMetric,
	episodeUpdateEngagement
}